import { TFunction } from 'i18next';
import { DomainRule } from '../domain/Workflow/types';

export interface RulesToMessagesMapper {
  map: (rules: DomainRule[]) => { error: string }[];
}

export class FailedRulesToMessagesMapper implements RulesToMessagesMapper {
  public constructor(private t: TFunction) {}

  public map(rules: DomainRule[]) {
    return rules.map(s => {
      switch (s.ruleKey) {
        default:
          return { error: this.t('onsite.editor.workflow.validation.rules.' + s.ruleKey) };
      }
    });
  }
}
